import { DashboardComponent } from '../../containers/adminDashboard/styles/DashboardStyles';
import { BrowserRouter as Router, Route, Switch, NavLink, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faUsers,
  faSeedling,
  faCalendar,
  faPoll,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import GroupsTabs from 'src/containers/adminDashboard/DiscipleshipCharts';
import Crecer from 'src/containers/adminDashboard/Crecer';
import Experiencia from 'src/containers/adminDashboard/Experiencia';
import Financiero from 'src/containers/adminDashboard/Financiero';
import { useEffect } from 'react';
import { Icon } from 'semantic-ui-react';

const AdminDashboard = () => {
  const iconMapping = {
    perfil: faHome,
    grupos: faUsers,
    crecer: faSeedling,
    eventos: faCalendar,
    encuestas: faPoll,
    experiencia: faStar,
  };

  const menuItems = [
    {
      path: '/tablero/grupos',
      label: 'Discipulado',
      iconType: 'semantic',
      iconName: 'users',
      activeClassName: 'activeExperiencia',
    },
    {
      path: '/tablero/crecer',
      label: 'Crecer',
      iconType: 'fontawesome',
      iconKey: 'crecer',
      activeClassName: 'activeExperiencia',
    },
    {
      path: '/tablero/experiencia',
      label: 'Experiencia',
      iconType: 'fontawesome',
      iconKey: 'experiencia',
      activeClassName: 'activeExperiencia',
    },
    {
      path: '/tablero/finanzas',
      label: 'Financiero',
      iconType: 'fontawesome',
      iconKey: 'perfil',
      activeClassName: 'activeExperiencia',
    },
  ];

  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (appElement) {
      appElement.style.backgroundColor = '#1d1d1b'; // Cambia el fondo a negro
    }

    return () => {
      if (appElement) {
        appElement.style.backgroundColor = ''; // Restaura el fondo original
      }
    };
  }, []);

  const renderIcon = (item) => {
    if (item.iconType === 'semantic') {
      return <Icon name={item.iconName} />;
    } else if (item.iconType === 'fontawesome') {
      return <FontAwesomeIcon icon={iconMapping[item.iconKey]} />;
    }
    return null;
  };

  return (
    <DashboardComponent>
      <Router>
        <div className="sidebar">
          <ul className="menuList">
            {menuItems.map((item, index) => (
              <li key={index}>
                <NavLink exact to={item.path} activeClassName={item.activeClassName}>
                  <span className="icon">{renderIcon(item)}</span>
                  <span className="text">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <Switch>
          <Route path="/tablero/grupos" component={GroupsTabs} />
          <Route path="/tablero/crecer" component={Crecer} />
          <Route path="/tablero/experiencia" component={Experiencia} />
          <Route path="/tablero/finanzas" component={Financiero} />
          <Redirect exact from="/tablero" to="/tablero/grupos" />
        </Switch>
      </Router>
    </DashboardComponent>
  );
};

export default AdminDashboard;
